import STORE from '../store';
import invalidateVisCache from './invalidateVisCache';

const updateReportGadget = async (
  id: string,
  gadget: ReportGadgets.ReportGadget,
  accountId: string,
) => {
  await STORE.visualisations
    .getReportGadgetsRef({ accountId })
    .doc(id)
    .set(gadget);

  await invalidateVisCache({
    accountId,
    changes: { reportGadgets: [id] },
  });

  return id;
};

export default updateReportGadget;
